<template>
    <div>
        <h1 class="quiz__title">Skincare Consultation</h1>

        <div class="quiz">
            <answer-summary />

            <router-view />
        </div>

        <quiz-nav />
    </div>
</template>

<script>
import QuizNav from './quiz-nav.vue'
import Sidebar from './sidebar.vue'

export default {
    name: 'Quiz',
    components: {
        'quiz-nav': QuizNav,
        'answer-summary': Sidebar,
    },
    data() {
        return {
            answers: [],
        }
    },
    created() {
    },
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/quiz.vue